import type { ApplicationType, UserRole } from './types';

// Execution steps in order
export const EXECUTION_STEPS = [
  'sensortypes',
  'usergroups',
  'sites',
  'locations',
  'sensorgroups',
  'sensors',
  'users',
  'notificationprotocols',
  'rulegroups',
] as const;

// Application type presets with default thresholds
export const APPLICATION_PRESETS: Record<
  ApplicationType,
  { label: string; unit: string; min: number | null; max: number | null }
> = {
  cold_storage: { label: 'Cold Storage', unit: '°C', min: -25, max: -15 },
  refrigerator: { label: 'Refrigerator', unit: '°C', min: 2, max: 8 },
  freezer: { label: 'Freezer', unit: '°C', min: -30, max: -15 },
  ultra_low_freezer: { label: 'Ultra-Low Freezer (-80°C)', unit: '°C', min: -90, max: -70 },
  room_temp: { label: 'Room Temperature', unit: '°C', min: 15, max: 25 },
  incubator: { label: 'Incubator', unit: '°C', min: 35, max: 39 },
  custom: { label: 'Custom', unit: '', min: null, max: null },
};

// User roles
export const USER_ROLES: { value: UserRole; label: string }[] = [
  { value: 'full admin', label: 'Full Admin' },
  { value: 'group admin', label: 'Group Admin' },
  { value: 'user', label: 'User' },
  { value: 'read only', label: 'Read Only' },
];

// File upload constraints
// Note: Only Excel files are supported. The backend /parse-excel endpoint
// does not accept CSV. CSV support uses a separate /convert endpoint not
// wired into the preview flow.
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ACCEPTED_FILE_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'application/vnd.ms-excel', // .xls
];
export const ACCEPTED_FILE_EXTENSIONS = ['.xlsx', '.xls'];

// Default empty user
export const DEFAULT_USER = {
  email: '',
  firstName: '',
  lastName: '',
  role: 'user' as UserRole,
  department: '',
  cellPhone: '',
  isAlertContact: false,
};

// Default empty equipment
export const DEFAULT_EQUIPMENT = {
  building: '',
  room: '',
  name: '',
  application: 'refrigerator' as ApplicationType,
  thresholdMin: 2,
  thresholdMax: 8,
  sku: '',
  calibrationCertificate: '',
  installationDate: '',
  installationCertificate: '',
  invoiceNumber: '',
  invoiceDate: '',
  comments: '',
};
